import { render } from "./Faces.vue?vue&type=template&id=7685cbe0&scoped=true"
import script from "./Faces.vue?vue&type=script&lang=js"
export * from "./Faces.vue?vue&type=script&lang=js"

import "./Faces.vue?vue&type=style&index=0&id=7685cbe0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7685cbe0"]])

export default __exports__